// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"78":"price","164":"terms","594":"about","694":"theme","962":"home","964":"product"}[chunkId] + "." + {"78":"115c5e12","164":"38a9d950","594":"99b4f113","694":"8801f1f2","962":"1f3bf1c6","964":"c388db04"}[chunkId] + ".css";
};